<template>
  <div>
    <div class="backlog" style="position: sticky; top: 0; z-index: 9">
      <div v-for="state in states" :key="state">
        <div class="mb-4">
          <v-chip variant="flat" color="primary" label
            ><span style="font-size: 9pt" class="text-smoke font-weight-bold">{{
              capitalize(state)
            }}</span>
            <v-icon size="x-small" color="smoke" class="ml-1"
              >mdi-arrow-down</v-icon
            >
          </v-chip>
          <v-btn
            v-if="state === 'done'"
            icon
            variant="text"
            size="small"
            @click="$store.dispatch('clearDoneState')"
            ><v-icon size="20">mdi-close</v-icon></v-btn
          >
        </div>
      </div>
    </div>
    <div class="backlog" v-if="!loading.admin.backlog">
      <div v-for="group in backlog" :key="group.id">
        <draggable
          v-model="group.items"
          :data-id="group.id"
          @change="onGroupsChange"
          group="backlog"
          :disabled="publicView"
          item-key="uid"
          :sort="true"
        >
          <template #item="{ element }">
            <v-card
              style="cursor: pointer"
              @click="$emit('open', element)"
              flat
              :data-id="group.id"
              class="card"
              :class="{ 'card--feature': element.type === 'Feature' }"
            >
              <div>
                <p class="ma-0 mb-1" style="font-weight: 600; font-size: 10pt">
                  {{ element.title }}
                </p>
                <p style="font-size: 10pt">{{ element.description }}</p>
                <v-chip class="mt-2" size="small" label
                  ><v-icon size="small" class="mr-1">{{
                    getIcon(element.type)
                  }}</v-icon
                  >{{ element.type }}</v-chip
                >
                <p class="mt-2" style="font-size: 9pt">
                  {{ element.suggested_by_email }}
                </p>
              </div>
            </v-card>
          </template>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapState } from "vuex";

export default {
  props: {
    publicView: {
      default: true,
    },
  },
  components: {
    draggable,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      backlog: (state) => state.admin.backlog,
    }),
  },
  data() {
    return {
      states: [
        "requested",
        "backlog",
        "in development",
        "ready for review",
        "done",
      ],
    };
  },
  methods: {
    capitalize(string) {
      let firstCharacter = string.charAt(0);
      firstCharacter = firstCharacter.toUpperCase();
      let capitalizedString = firstCharacter + string.slice(1);
      return capitalizedString;
    },
    stateCamel(state) {
      let newstate = state.replaceAll(" ", "_");
      return newstate;
    },
    async onGroupsChange(event) {
      console.log(event);
      await this.$store.dispatch("updateBacklogOrder");
    },
    getIcon(type) {
      if (type === "Bug/issue") {
        return "mdi-bug-outline";
      } else if (type === "Question") {
        return "mdi-help-circle-outline";
      } else if (type === "Feature") {
        return "mdi-lightbulb-outline";
      } else if (type === "Improvement") {
        return "mdi-lightbulb-outline";
      } else if (type === "Other") {
        return "mdi-dots-vertical";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.backlog {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 20px;
}
.card {
  padding: 15px 20px;
  margin-bottom: 10px;
  border-bottom: 3px solid #272727;
  border-left: 1px solid #272727;
  border-top: 1px solid #272727;
  border-right: 3px solid #272727;
}

.card--feature {
  border-color: rgb(var(--v-theme-error));
}
</style>
